import React from 'react';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import './ModalAddElementsDict.scss'
import { TitlePage } from '../../../../components/TitlePage/TitlePage';
import { ButtonBasic, TextareaDynamicPlaceholder, Checkbox, ButtonClose } from '@lk-gtcom/ecomlab-components';
import { TextPage } from '../../../../components/TextPage/TextPage';

interface ModalAddElementsDictProps {
    list?: any,
    setList?: (e: any) => void
    setIsModal: (e: boolean) => void
}

const ModalAddElementsDict = ({
    setIsModal,
    list = [],
    setList = () => { }
}: ModalAddElementsDictProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const [listPoints, setListPoints] = useState(list || []);
    const [checkedValues, setCheckedValues] = useState([]);
    const [textareaValue, setTextareaValue] = useState('');
    const [existingValues, setExistingValues] = useState([]);
    const [showGenModal, setShowGenModal] = useState(false);
    const [copiedFields, setCopiedFields] = useState([]);

    useEffect(() => {
        setList(listPoints)
    }, [listPoints]);

    const handleCheckboxChange = (fieldId) => {
        setCopiedFields((prev) =>
            prev.includes(fieldId)
                ? prev.filter((id) => id !== fieldId)
                : [...prev, fieldId]
        );
    };

    const handleAddPoints = () => {
        if (!textareaValue.trim()) return;

        const newItems = textareaValue
            .split('\n')
            .filter((line) => line.trim() && !existingValues.includes(line.trim()));

        setListPoints((prev) => [...prev, ...newItems]);
        setTextareaValue('');
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleAddPoints();
        }
    };

    const handleDeleteCheckedAttr = () => {
        setListPoints((prevPoints) =>
            prevPoints.filter((_, index) => !checkedValues.includes(index))
        );
        setCheckedValues([]);
    };

    return (
        <div
            className='blackout'
            style={{ zIndex: 11 }}
            onClick={(e) => {
                let el = e.target as HTMLElement
                if (el.classList.contains('blackout')) {
                    setIsModal(false)
                }
            }}
        >
            <div className='modal-add-elements-dict'>
                <header className='modal-add-elements-dict__header'>
                    <TitlePage
                        title='Добавить элементы списка'
                    />

                    <ButtonClose
                        onClick={(e) => setIsModal(false)}
                    />
                </header>


                <div className='modal-add-elements-dict__content'>

                    <TextareaDynamicPlaceholder
                        changeValue={textareaValue}
                        width={'100%'}
                        placeholder="Введите значения списка через Enter"
                        onChange={(e) => setTextareaValue(e)}
                        onKeyDown={handleKeyDown}
                    />

                    <div className='modal-add-elements-dict__btn-group'>
                        <ButtonBasic
                            lilac
                            width='auto'
                            onClick={handleAddPoints}
                            text="Добавить"
                        />

                        <ButtonBasic
                            red
                            width='auto'
                            disabled={!checkedValues?.length}
                            text="Удалить"
                            onClick={() => {
                                handleDeleteCheckedAttr();
                            }}
                        />
                    </div>

                    <div className="modal-add-elements-dict__checkbox-group">
                        {listPoints.map((item, idx) => (
                            <label className="modal-add-elements-dict__label" key={idx}>
                                <Checkbox
                                    value={checkedValues.includes(idx)}
                                    onChange={() =>
                                        setCheckedValues((prev) =>
                                            prev.includes(idx)
                                                ? prev.filter((i) => i !== idx)
                                                : [...prev, idx]
                                        )
                                    }
                                />
                                <TextPage
                                    text={item?.label || item}
                                />

                                {showGenModal && (
                                    <Checkbox
                                        value={copiedFields.includes(item)}
                                        onChange={() => handleCheckboxChange(item)}
                                    >
                                        <p style={{ fontSize: '10px' }}>Copy ID</p>
                                    </Checkbox>
                                )}
                            </label>
                        ))}
                    </div>
                </div>

                <div className='modal-add-elements-dict__btn-group-down'>
                    <ButtonBasic
                        green
                        onClick={(e) => {
                            setIsModal(false)
                        }}
                        size='56px'
                        text="Сохранить"
                    />
                </div>
            </div>
        </div>
    )
}

export { ModalAddElementsDict }